import React, {PureComponent} from 'react';

import './CollapseMaster.css';
import MainBoxCollapsible from './MainBoxCollapsible/MainBoxCollapsible';
import {MenuOptionsHeader} from "./MenuOptions/MenuOptionsHeader";

class CollapseMaster extends PureComponent {
  state = {
    title: 'title',
    active: '',
  };

  parseMenuOptions = () => {
    const {items} = this.props;
    return items.map((element, index) => ({name: element.title, index: index, id: element.id}))
  };

  handleActive = (index) => {
    const {active} = this.state;
    const newValue = index === active ? '' : index;

    this.setState({active: newValue});
  };

  render() {
    const {active} = this.state;
    const {items, title} = this.props;

    const menuOptions = this.parseMenuOptions();
    return (
      <div id='Collapse-master'>
        <div className='title-collapse-master'>
          <div className='title-main'><span>{title}</span></div>
          <div className='title-menu'>
            <MenuOptionsHeader
              selection={active}
              options={menuOptions}
              handleActive={this.handleActive}
            />
          </div>
        </div>
        <div className='content-component'>
          {items.map((value, index) => {
            return (
              <MainBoxCollapsible
                key={index}
                index={index}
                isActive={active === index}
                title={value.title}
                id={value.id}
                color={value.color}
                image={value.image}
                content={value.content}
                handleActive={this.handleActive}
                subItems={value.subItems}
                subContent={value.subContent}
              />
            );
          })}
        </div>
      </div>
    );
  }
}

export default CollapseMaster;



// WEBPACK FOOTER //
// ./src/components/CollapseMaster/CollapseMaster.js